import { Drawer, styled } from '@mui/material';

// Note: zIndex.appBar - 1 to handle sidebar under Navigation Bar
export const MobileDrawer = styled(Drawer)(({ theme: { zIndex } }) => ({
  zIndex: zIndex.appBar - 1,
}));
